<template>
<div class="score-melody">
    <div v-for="(notes, beat) in phrase['alt_0']" :key="'Beat-' + number + '-' + beat" :id="'Beat-' + number + '-' + beat" class="beat-melody">
        <div v-if="beat && is_a_melody_beat(beat)" class="choose-mel" :disabled="disabled" @click="next_option(beat)">

            <div class="beat-score-melody">
                <div v-for="(note, index) in options_at_beat(beat)" :key="'Note-' + index" :id="'Note-' + index" class="note-melody" >
                    <!--<VueLottiePlayer v-if="beat_changed == beat" :loop=2 autoplay name="workoutMonkeyAnim" :animationData="require('@/assets/animations-b/colcheia.json')" width="5.0rem" height="100%" />-->
                    <img  v-if="phrase[beat] != ''" :src="require('@/assets/figures-b/barrigas/fig-' + note[0] + '.png')" />
                </div>

                <div class="note-melody" >
                    <img v-if="phrase[beat] == ''" :src="require('@/assets/figures-b/barrigas/fig-6.png')" class="hidden-melody" />
                </div>
            </div>
        </div>
        <div v-else class="beat-score-melody">
            <span v-for="(note, index) in notes" :key="'Note-' + index" :id="'Note-' + index" class="note-melody">
                <img :src="require('@/assets/figures-b/barrigas/fig-' + note[0] + '.png')" />
            </span>
        </div>
    </div>
</div>
</template>

<script>
//import VueLottiePlayer from "vue-lottie-player";

export default {
    name: 'PhraseDisplay',
    emits: ['altered_option'],
    components: {
        //VueLottiePlayer
    },
    props: {
        phrase: Object,
        number: String,
        options: Object,
        disabled: Boolean
    },
    data() {
        return {
            beat_changed: 0,
        }
    },
    methods: {
        is_a_melody_beat(beat) {
            return this.phrase['different_rhythm_beats'].indexOf(parseInt(beat)) > -1;
        },
        options_at_beat(beat) {
            if (this.options !== undefined) {
                let opts = this.options[beat];
                if (opts === '') return '';
                return this.phrase[opts][parseInt(beat)];
            }
            return '';
        },
        next_option(beat) {
            let opt = "alt_0"
            switch (this.options[beat]) {
                case "alt_0":
                    opt = "alt_1";
                    break;
                case "alt_1":
                    opt = "alt_2";
                    break;
                default:
                    opt = "alt_0";
                    break;
            }
            this.beat_changed = beat;
            this.$emit('altered_option', [this.number, beat, opt]);
        },
    }
}
</script>

<style>
.score-melody {
    width: 80%;
    height: 100%;
}
.beat-melody{
    height: 17%;
    display: flex;
    justify-content: center;
}

.beat-score-melody {
    justify-content: center;
    display: flex;
    width: 100%;
    height: 100%;
    /*border: solid 1px coral;*/
}

.note-melody > img{
    width: 100%;
    height: 100%;
   /* margin: 0-1.2rem;*/
}
.note-melody{
    margin:0 -26%;
}

.hidden-melody {
    visibility: hidden;
}
.visible-melody {
    display: none;
}

.choose-mel[disabled=true] {
    pointer-events: none;
    background: none !important;
}

/*
.choose-melody {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1em;
    height: 4em;
    padding: 1em;
}

.choose-mel > .beat-score-melody > #Note-0 {
    margin: 0;
}*/

.choose-mel {
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 1em;
    width: auto !important;
    padding: 0 4.5rem 0 0.8rem;
}


@media only screen and (max-width: 480px) {
    .choose-mel {
       padding: 0 1.5rem 0 0.2rem;
               border-radius: 8px;

    }
        .note-melody {
        margin: 0 -0.6rem;
    }
}


@media only screen and (min-width: 481px) and (max-width: 550px) {
    .choose-mel {
        padding: 0 1.2rem 0 0.3rem;
                border-radius: 8px;

    }
        .note-melody {
        margin: 0 -0.5rem;
    }
}

@media only screen and (min-width: 551px) and (max-width: 630px) {
    .choose-mel {
        padding: 0 1.3rem 0 0.4rem;
        border-radius: 9px;
    }
        .note-melody {
        margin: 0 -0.5rem;
    }
}

@media only screen and (min-width: 631px) and (max-width: 718px) {
    .choose-mel {
        padding: 0 1.6rem 0 0.4rem;
        border-radius: 11px;
    }
        .note-melody {
        margin: 0 -0.6rem;
    }
}

@media only screen and (min-width: 719px) and (max-width: 806px) {
    .choose-mel {
        padding: 0 1.8rem 0 0.5rem;
        border-radius: 12px;
    }
        .note-melody {
        margin: 0 -0.7rem;
    }
}

@media only screen and (min-width: 806px) and (max-width: 1024px) {
    .choose-mel {
        padding: 0 2.5rem 0 0.7rem;
        border-radius: 13px;
    }

    .note-melody {
        margin: 0 -0.9rem;
    }
}

@media only screen and (min-width: 1024px) and (max-width: 1200px) {
    .choose-mel {
        padding: 0 3.5rem 0 0.8rem;
        border-radius: 14px;
    }

    .note-melody {
        margin: 0 -1.1rem;
    }
}

@media only screen and (min-width: 1200px) and (max-width: 1366px) {
    .choose-mel {
        padding: 0 3.6rem 0 0.9rem;
        border-radius: 15px;
    }

    .note-melody {
        margin: 0 -1.2rem;
    }
}

@media only screen and (min-width: 1366px) and (max-width: 1540px) {
    .choose-mel {
        padding: 0 4.5rem 0 1rem;
        border-radius: 16px;
    }

    .note-melody {
        margin: 0 -2rem;
    }
}

@media only screen and (min-width: 1540px) and (max-width: 1680px) {
    .choose-mel {
        padding: 0 4.8rem 0 1.2rem;
        border-radius: 20px;
    }

    .note-melody {
        margin: 0 -2.4rem;
    }
}

@media only screen and (min-width: 1680px) and (max-width: 2350px) {
    .choose-mel {
        padding: 0 5.4rem 0 1.2rem;
         border-radius: 25px;
    }

    .note-melody {
        margin: 0 -2.6rem;
    }
}

@media only screen and (min-width: 2350px) {
    .choose-mel {
            padding: 0 7rem 0 1.3rem;
            border-radius: 30px;
    }
    .note-melody {
        margin: 0 -3rem;
    }

}
</style>
